import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import { TableCell, TableRow } from "@mui/material";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import * as S from "./styles";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { RowHeaderTextCenter, RowHeaderTextEnd } from "../styles";
import ResultNotFoundComponent from "../resultNotFound/resultNotFoundComponent";

export interface ISpecialAccount {
	guid?: string;
	guidInsurer: string;
	name: string;
	agentKey: string;
	totalLossPercentage?: number | null;
	users: Array<{
		guidSpecialAccountUser?: string;
		idUser: string;
		name: string;
	}>;
}
export function formatTotalLossPercentageCell(value: number | null | undefined): string {
	if (isNullUndefined(value)) {
		return getTranslateByKey("information.specialAccountsUndefinedPercentage");
	}

	const roundedValue = Math.round(value * 100) / 100;
	return `${roundedValue.toString().replace(".", ",")}%`;
}

interface ISpecialAccountsGridProps {
	data: ISpecialAccount[];
	onEdit: (specialAccount: ISpecialAccount) => void;
	onDelete: (guid: string) => void;
}

function SpecialAccountsGrid({ data, onEdit, onDelete }: ISpecialAccountsGridProps) {
	const rowHeaders = [
		getTranslateByKey("information.specialAccountsTextScreenName"),
		getTranslateByKey("information.specialAccountsTextScreenAgent"),
		getTranslateByKey("information.specialAccountsTextScreenUsers"),
		<RowHeaderTextEnd key="3">
			{getTranslateByKey("information.specialAccountsTextScreenTotalLossPercentage")}
		</RowHeaderTextEnd>,
		<RowHeaderTextCenter key="4">
			{" "}
			{getTranslateByKey("information.specialAccountsTextScreenActions")}
		</RowHeaderTextCenter>,
	];
	return (
		<BoxGrid rowHeaders={rowHeaders} marginCustom="1rem 0 0 0">
			{data.length > 0 ? (
				data.map((specialAccount) => (
					<TableRow key={specialAccount.agentKey}>
						<TableCell width="30%">{specialAccount.name}</TableCell>
						<TableCell width="20%">{specialAccount.agentKey}</TableCell>
						<TableCell width="30%">{specialAccount.users.map((user) => user.name).join(", ")}</TableCell>
						<TableCell width="10%" align="right">
							{formatTotalLossPercentageCell(specialAccount.totalLossPercentage)}
						</TableCell>
						<TableCell width="10%">
							<div style={{ display: "flex", justifyContent: "center" }}>
								<S.TextValue cursor="pointer">
									<CreateIcon onClick={() => onEdit(specialAccount)} id="id-register-icon-editSpecialAccount" />
								</S.TextValue>
								<S.TextValue cursor="pointer">
									<CloseIcon
										onClick={() => onDelete(specialAccount.guid ?? "")}
										id="id-register-icon-deleteSpecialAccount"
									/>
								</S.TextValue>
							</div>
						</TableCell>
					</TableRow>
				))
			) : (
				<TableRow>
					<TableCell colSpan={rowHeaders.length} style={{ textAlign: "center" }}>
						<ResultNotFoundComponent />
					</TableCell>
				</TableRow>
			)}
		</BoxGrid>
	);
}

export default SpecialAccountsGrid;
